import { useEffect } from 'react'

import { withClientSide } from '@utils/client-side'
import { storage, storageKey } from '@lib/storage'
import { useQueryParams } from './query-params'

export function useAttribution() {
  const queryParams = useQueryParams()
  const queryAffiliateId = (queryParams.af ?? queryParams.affiliateId) as
    | string
    | undefined
  const queryAttributionId = (queryParams.at ?? queryParams.attributionId) as
    | string
    | undefined

  const storageAffiliateId = withClientSide(() =>
    storage.local.getByKey<string>(storageKey.affiliateId)
  )
  const storageAttributionId = withClientSide(() =>
    storage.local.getByKey<string>(storageKey.attributionId)
  )
  const affiliateId = queryAffiliateId || storageAffiliateId
  const attributionId = queryAttributionId || storageAttributionId

  useEffect(() => {
    if (affiliateId) {
      storage.local.setByKey(storageKey.affiliateId, affiliateId)
    }
    if (attributionId) {
      storage.local.setByKey(storageKey.attributionId, attributionId)
    }
  }, [affiliateId, attributionId])

  return { affiliateId, attributionId }
}
